import React, {useState} from 'react';
import useMeasure from 'react-use-measure';
import Media from 'react-media';
import {Link} from 'react-router-dom';
import {makeStyles} from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Logo from '../images/ais-cut-logo.png';
import CallIcon from '@material-ui/icons/Call';
import Dropdown from './Dropdown';
import {useSpring, animated} from 'react-spring';
import '../css/Header.css';

const useStyles = makeStyles(() => ({
  toolbar: {
    background: '#173747',
    height: '150px',
    fontFamily: 'Roboto, sans-serif',
  },
  topbar: {
    display: 'flex',
    flexDirection: 'row',
    height: '50px',
    background: `linear-gradient(0deg, rgba(100, 100, 
        100,1) 0%, rgba(255, 255, 255,1) 120%)`,
  },
  dropdown: {
    float: 'right',
    color: '#737373',
  },
  contact: {
    position: 'absolute',
    top: 10,
    right: 25,
    color: 'black',
    textShadow: '1px 1px grey',
    '&:hover': {
      textDecoration: 'none',
      color: 'black',
    },
    '&:visited': {
      textDecoration: 'none',
    },
  },
  contactFlex: {
    display: 'flex',
    flexDirection: 'row',
  },
  callIcon: {
    marginTop: '22px',
  },
  logo: {
    width: '300px',
    position: 'absolute',
    zIndex: 99,
    marginLeft: '60px',
    pointervents: 'none',
  },
  logoMobile: {
    width: '300px',
    marginTop: '90px',
    position: 'absolute',
    zIndex: 99,
  },
}));

/**
 * A logo component for AIS
 * @component HeadLogo
 * @return {Component} HeadLogo component
 */
function HeadLogo() {
  const classes = useStyles();
  return (
    <Link to="/">
      <img src={Logo} alt="logo" className={classes.logo} />
    </Link>
  );
}

/**
 * The logo component for AIS logo
 * @component HeadLogoMobile
 * @return {Component} HeadLogoMobile component
 */
function HeadLogoMobile() {
  const classes = useStyles();

  return (
    <Link to="/">
      <img src={Logo} alt="logo" className={classes.logoMobile} />
    </Link>
  );
}

/**
 * The component for the header
 * @component Header
 * @return {Component} Header component
 */
export default function Header() {
  const classes = useStyles();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [ref, bounds] = useMeasure();

  const panelContentAnimatedStyle = useSpring({
    height: isCollapsed ? 0 : bounds.height,
  });

  return (
    <React.Fragment>
      <Media query="(max-width: 900px)">
        {(matches) => {
          return matches ? (
            <div>
              <div className="header-mobile-root">
                <div className="header-menu-logo">
                  <HeadLogoMobile />
                </div>
                <div className="header-mobile-empty"></div>
                <div className="header-mobile-menu">
                  <button
                    type="button"
                    className="header-menu-button"
                    onClick={() => setIsCollapsed(!isCollapsed)}
                  >
                    <i
                      id="header-menu-button-icon"
                      className="fa fa-bars"
                      style={{}}
                    />
                  </button>
                </div>
              </div>
              {/* -------------------- */}
              {/* Mobile Dropdown Menu */}
              {/* -------------------- */}
              {isCollapsed && (
                <animated.div
                  className="header-mobile-content"
                  style={panelContentAnimatedStyle}
                  ref={ref}
                >
                  <h1>Services</h1>
                  <a href="/innovations">
                    <p>Innovations</p>
                  </a>
                  <a href="/research">
                    <p>Research</p>
                  </a>
                  <a href="/products">
                    <p>Product Catalog</p>
                  </a>
                  <a href="/client-login">
                    <p>Client Portal</p>
                  </a>
                  <h1>Community</h1>
                  <a href="/newsroom">
                    <p>Newsroom</p>
                  </a>
                  <a href="/ethics">
                    <p>Ethics</p>
                  </a>
                  <a href="/investor">
                    <p>Investor Relations</p>
                  </a>
                  <a href="/events">
                    <p>Events</p>
                  </a>
                  <h1>Knowledge Base</h1>
                  <a href="/faq">
                    <p>FAQ</p>
                  </a>
                  <a href="/products">
                    <p>Encyclopedia</p>
                  </a>
                  <a href="/support">
                    <p>Support</p>
                  </a>
                  <a href="/legal">
                    <p>Legal</p>
                  </a>
                </animated.div>
              )}
            </div>
          ) : (
            <div draggable="false" className={classes.toolbar}>
              <HeadLogo />
              <div className="header-topbar">
                <svg
                  width="1300"
                  height="150"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 100 10"
                  preserveAspectRatio="none"
                >
                  <polygon fill="#949494" points="34 0 42 20 -70 0" />
                  <polygon fill="#333333" points="33 0 41 20 -70 0" />
                  <polygon fill="#000000" points="32 0 40 20 -70 0" />
                </svg>
                <div
                  className="btn-group"
                  style={{
                    marginLeft: 'auto',
                    marginRight: '50px',
                    order: 2,
                    height: '40px',
                    marginTop: 'auto',
                    marginBottom: '6px',
                  }}
                >
                  <div
                    className="dropdown-menu"
                    style={{marginLeft: '-17px', marginTop: '5px'}}
                  >
                    <a className="dropdown-item" href="/employee-login">
                      Employee
                    </a>
                    <a className="dropdown-item" href="/clientlogin">
                      Client
                    </a>
                  </div>
                </div>
                <a href="/support" className={classes.contact}>
                  <div className={classes.contactFlex}>
                    <p>Call Fax Toll-Free &nbsp;</p>
                    <CallIcon
                      className={classes.callIcon}
                      style={{
                        marginTop: '4px',
                      }}
                    />
                    <p>&nbsp;1-800-427-9479</p>
                  </div>
                </a>
              </div>
              <Toolbar className={classes.dropdown}>
                <Dropdown />
              </Toolbar>
            </div>
          );
        }}
      </Media>
    </React.Fragment>
  );
}
